import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteCreatePage } from '@/features/institutes/pages/InstituteCreatePage';

export const Route = createFileRoute('/_auth/settings/institutes/create')({
  component: () => (
    <ErrorBoundary moduleName="Create Institute">
      <Suspense fallback={<PageLoader />}>
        <InstituteCreatePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
